module.exports = __webpack_public_path__ + "static/media/Cursos_Presenciais-05.d1abf16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Cursos_Presenciais-05.jpg
// module id = 1465
// module chunks = 0